import Api from "@/services/api";

// Thin, isolated wrappers around the new pay-first Message IQ signup endpoints.
// These endpoints are anonymous (no Auth0 token exists yet for the visitor),
// so no Authorization header is attached to any of these calls.
//
// NOTE: Backend is being built in parallel in the messageiq repo. If the
// route paths or payload/response shapes below need to be reconciled, this
// is the only file that should need to change.
//
// Assumed contract:
//   GET  /api/Web/MessageIqSignup/{planId}/plan
//   POST /api/Web/MessageIqSignup/payment   -> { signupToken, expiresAt }
//   POST /api/Web/MessageIqSignup/complete  (header: X-Signup-Token)

export default {
    async getPlan(planId) {
        return Api().get(`/Web/MessageIqSignup/${planId}/plan`);
    },

    async submitPayment(payload) {
        // payload: { planId, firstName, lastName, email, address, address2, city, state, zip, token, companyName }
        return Api().post(`/Web/MessageIqSignup/payment`, payload);
    },

    async completeSignup(signupToken, payload) {
        // payload: { companyName, website, timeZone, address, address2, city, state, zip, firstName, lastName, phone, password }
        const config = {
            headers: { "X-Signup-Token": signupToken }
        };
        return Api().post(`/Web/MessageIqSignup/complete`, payload, config);
    }
};
